import { DeleteOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, Upload } from "antd";
import { memo, ReactElement } from "react";
import { IDocButtonsProps } from "../../../../../interfaces/props/IDocButtonsProps";
import { STATUS_APPLICATION } from "../../../../../types/indexTypeEnum";
import { APPLICATION_BANK_STATUS_KKB } from "../../../../../utils/guards/ApplicationBankStatusGuard/types";
import { Guard } from "../../../../../utils/guards/Guard";

import classes from "./DocButtons.module.css";

function DocButtons(props: IDocButtonsProps): ReactElement {
  const {
    isUploadingDocument,
    isDocBolean,
    isDocSigned,
    deleteDocument,
    beforeUpload,
    Tag,
    applicationBankStatus,
    icon,
    disabled,
  } = props;

  function onDelete() {
    deleteDocument();
  }

  /* Даем возможность изменять документы только если они не подписаны - на всех ролях, кроме статуса сделка завершена. Так же если карточка банка показывается на роли КО и висит на статусе "На доработке" - так же даем изменять документ */
  function conditionDefaultUploadIcon() {
    if (
      applicationBankStatus === APPLICATION_BANK_STATUS_KKB.AWAITING_PAYMENT
    ) {
      return false;
    }

    if (
      !isDocSigned &&
      applicationBankStatus !== APPLICATION_BANK_STATUS_KKB.DEAL_COMPLETED
    ) {
      return true;
    }

    if (
      applicationBankStatus &&
      applicationBankStatus === APPLICATION_BANK_STATUS_KKB.REVISION
    ) {
      return true;
    }

    return false;
  }

  const iconNode = icon ? (
    icon
  ) : (
    <>
      {conditionDefaultUploadIcon() && (
        <Upload
          className={classes.uploadWrapper}
          showUploadList={false}
          customRequest={beforeUpload}
        >
          <Button
            className={classes.uploadButton}
            disabled={disabled}
            data-cy={"button-upload-document-icons"}
            type="link"
            loading={isUploadingDocument}
          >
            <UploadOutlined className={classes.uploadIcon} />
            <span className={classes.uploadText}>Загрузить</span>
          </Button>
        </Upload>
      )}

      <Guard.ApplicationStatus allowedStatuses={[STATUS_APPLICATION.DRAFT]}>
        <Button
          className={classes.deleteButton}
          type="link"
          onClick={onDelete}
          disabled={!isDocBolean}
        >
          <DeleteOutlined />
        </Button>
      </Guard.ApplicationStatus>
    </>
  );

  return (
    <div className={classes.buttonWrapper}>
      {Tag}
      {iconNode}
    </div>
  );
}

export default memo(DocButtons);
